/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An administrator's answer: plain text, 1 to 5000 characters.
 * @export
 * @interface EventQuestionAnswer
 */
export interface EventQuestionAnswer {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionAnswer
     */
    answer_text: string;
}

/**
 * Check if a given object implements the EventQuestionAnswer interface.
 */
export function instanceOfEventQuestionAnswer(value: object): value is EventQuestionAnswer {
    if (!('answer_text' in value) || value['answer_text'] === undefined) return false;
    return true;
}

export function EventQuestionAnswerFromJSON(json: any): EventQuestionAnswer {
    return EventQuestionAnswerFromJSONTyped(json, false);
}

export function EventQuestionAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'answer_text': json['answer_text'],
    };
}

export function EventQuestionAnswerToJSON(json: any): EventQuestionAnswer {
    return EventQuestionAnswerToJSONTyped(json, false);
}

export function EventQuestionAnswerToJSONTyped(value?: EventQuestionAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answer_text': value['answer_text'],
    };
}

